import React from 'react';
import './Booking.css';

import { BookingForm } from '../../../components';


const Booking = () => (

  <section className="home-booking">
    <div className="box-container">
      <div className="content">
        <BookingForm formType="home-booking" />
      </div>
    </div>
  </section>

);

export default Booking;